const Sdata=[
    {
    "id": 1,
    "title": "The future of possible innovation for local business company.",
    "description": "Stay focused and remember we design the best WordPress News and Magazine Themes. It’s the ones closest to you that want to…",
    "category": "1",
    "image": "https://html.dynamiclayers.net/dl/news24/img/sports-1.jpg",
    },
    {
    "id": 2,
    "title": "Portugal Switzerland Bahamas",
    "description": "Proof That Bahamas Beaty Really Works",
    "category": "2",
    "image": "https://html.dynamiclayers.net/dl/news24/img/sports-2.jpg",
    },
    {
    "id": 3,
    "title": " Africa Canada Portugal",
    "description": "Win Friends And Influence People with canada tour",
    "category": "3",
    "image": "https://html.dynamiclayers.net/dl/news24/img/sports-3.jpg",
    },
    {
        "id": 4,
        "title": "Portugal Jamaica",
        "description": "Now You Can Have",
        "category": "1",
        "image": "https://html.dynamiclayers.net/dl/news24/img/sports-4.jpg",
        },
        {
            "id": 5,
            "title": "Portugal Jamaica",
            "description": "Now You Can Have",
            "category": "1",
            "image": "https://html.dynamiclayers.net/dl/news24/img/sports-5.jpg",
            },
]
export default Sdata;